
import IftaLabel from 'primevue/iftalabel';
import Button from 'primevue/button';
import { useWebStore } from '../stores/web';
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import PopupMainNavbar from '../components/navbar/PopupMainNavbar.vue';
import PopupAffiliateNavbar from '../components/navbar/PopupAffiliateNavbar.vue';

export default {
	name: 'Contact',
	components: {
		IftaLabel,
		Button,
	},
	setup() {
		const web = useWebStore();
		web.hydrate();

		const { webPermission, managerConfig } = storeToRefs(web);

		// LINE support id comes from the manager (operator source of truth) when
		// set; otherwise keep the previous hardcoded id / hkthg contact url.
		const mgrLineId = computed<string>(() => managerConfig.value?.theme?.lineId ?? '');
		const lineDisplay = computed<string>(() => mgrLineId.value || '@1688tos');
		const lineUrl = computed<string>(() =>
			mgrLineId.value
				? `https://line.me/R/ti/p/${encodeURIComponent(mgrLineId.value)}`
				: (webPermission.value?.contact?.line.url || ''),
		);

		const clickLink = (link: string) => {
			if (!link) return;
			window.open(link, '_blank');
		};

		return {
			webPermission,
			lineDisplay,
			lineUrl,
			clickLink,
		};
	},
};
